/**
 * Hose option lists are stored in the order somebody happened to add them, so
 * a dropdown showed "ø19/27, ø16/24, ø25/34" (client #88). Sorting on read
 * keeps the stored order untouched — no migration — while every list that
 * reaches the technician is predictable.
 *
 * Numeric-aware so "ø9" sorts before "ø16" rather than after it.
 */
export const sortOptions = (items: readonly string[]): string[] =>
  [...items].sort((a, b) =>
    a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
  );

/**
 * What a hose dropdown offers: the list, sorted, plus the value the hose
 * already holds when the list does not carry it. A Select given a value none
 * of its items match renders "not set", which hides real data behind an
 * outdated or differently-spelled option list (client #89).
 */
export const optionsWith = (
  list: readonly string[],
  current?: string
): string[] =>
  sortOptions([...new Set([...list, ...(current ? [current] : [])])]);
